"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
exports.EyeToggle = ({ active, onChange, show }) => {
    return (react_1.default.createElement(reactstrap_1.InputGroupAddon, { addonType: "append" },
        react_1.default.createElement(reactstrap_1.InputGroupText, { className: "bg-white text-muted border-left-0" },
            react_1.default.createElement(reactstrap_1.Fade, { in: show },
                react_1.default.createElement("a", { href: "#", className: "text-reset", onClick: e => {
                        e.preventDefault();
                        onChange(!active);
                    } },
                    react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: active ? 'show' : 'hide' }))))));
};
//# sourceMappingURL=EyeToggle.js.map